/* eslint-disable no-unused-expressions */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Input,
  Tabs,
  DatePicker,
  message,
  Typography,
  InputNumber,
} from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, RedoOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import NumericInput from 'components/NumericInput';
import PercentageInput from 'components/PercentageInput';
import CurrencyInput from 'components/CurrencyInput';
import { makeOnChangeTabKey } from 'utils/tabsManagement';
import makeMessager from 'utils/complexFormsMessages';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import SectionCard from 'components/SectionCard';
import ModalConfirmation from 'components/ModalConfirmation';
import {
  getEstadosGlobales,
  getCOGS,
  getClasificadoresObjetosGasto,
  getTipoDeGasto,
  getFuentesDeFinanciamiento,
  getCuentasContables,
} from 'api/catalogos/index';
import {
  getPercepciones,
  postPercepcion,
  deletePercepcion,
  patchPercepcion,
  getPercepcion,
} from 'api/nominas/percepciones/percepciones';
import {
  getPercepcionesParametrosDiversos,
} from 'api/PercepcionesParametrosDiversos.api';
import { getTiposDeEmpleadosPresupuestales } from 'api/catalogos/tiposDeEmpleadosPresupuestales';
import {
  getPeriodicidadDePercepciones,
} from 'api/nominas/percepciones/periodicidadDePercepciones';
import {
  getConfiguracionDescuentos,
} from 'api/nominas/descuentos/configuracionDescuentos';
import {
  getCATSATOrigenesRecursos,
} from 'api/nominas/catalogos/CATSATOrigenesRecursos';
import {
  getClasificadoresObjetoGastoUnion,
} from 'api/configuraciones/clasificadorObjetoGasto';
import {
  getCATSATPercepciones,
} from 'api/nominas/catalogos/CATSATPercepciones';
import makeTree from 'utils/makeTree';
import makeTreeCuentasContable from 'utils/makeTreeFromCuentasContables';
import { SLUG_PATTERN, FLOAT_NUMER_PATTERN, integerRegExp } from 'utils/patterns';
import { checkToken } from 'api/utils';
import { getModelPermission } from 'utils/permission';
import {
  ESTATUS_ACTIVO,
  ESTATUS_CANCELADO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import API from 'utils/api';
import { getPagosInformativosSAT } from 'api/catalogos/PagosInformativosSAT';
import { getOtrosTiposDePagoNomina } from 'api/catalogos/otrosTiposPagoNominas';
import { set } from 'lodash';
import * as XLSX from 'xlsx';
import { getTiposDeEmpleados } from 'api/catalogos/tiposDeEmpleados';
import moment from 'moment';
import { getAreasExternas } from 'api/catalogos/AreaExterna';
import { getFormasDePagos } from 'api/catalogos/formasDePagos';
import { getMetodosDePagos } from 'api/catalogos/metodosDePagos';
import PercepcionClaseDeContratacion, { percepcionClaseDeContratacionPermission } from './PercepcionesClasesDeContrataciones';
import PercepcionConfiguracionAntiguedad, { percepcionConfiguracionAntiguedadPermission } from './PercepcionesConfiguracionesAntiguedades';
import PercepcionTipoDeEmpleado, { percepcionTipoNominaPermission } from './PercepcionesTiposDeEmpleado';
import PercepcionTipoDeNominaEmpleado, { percepcionTipoNominaEmpleadoPermission } from './PercepcionesTiposDeNominasEmpleados';
import PercepcionFechaFijaPago from './PercepcionesFechaFijaPago';
import RegistroContablePercepciones from './RegistroContablePercepciones';
import PercepcionesParametrosDiversos from './PercepcionesParametrosDiversos';
import PercepcionIncidenciasReloj from './PercepcionesIncidenciaRelojChecador';
import PercepcionImportePuesto from './PercepcionesImportePorPuesto';
import PercepcionImportePlaza from './PercepcionesImportePorPlaza';
import PercepcionesLimiteMaximo from './PercepcionesLimiteMaximo';
import PercepcionTiposDeEmpleadoConfig from './PercepcionesTiposDeEmpleadoConfig';
import PercepcionesExcluirPorTipoDeEmpleadoConfig from './PercepcionesExcluirPorTipoDeEmpleadoConfig';

const { TabPane } = Tabs;

export const onErrorFields = (
  err,
  setLoading = null,
  formsInstances = [],
  setCurrentTabKey,
) => {
  // eslint-disable-next-line no-console
  if (typeof setLoading === 'function') {
    setLoading(false);
  }
  const errorKeys = err.errorFields.map((e) => e.name[0]);
  const formWithErrors = formsInstances.find(
    (obj) => obj.tabFields.some(
      (val) => errorKeys.includes(val),
    ),
  );
  if (formWithErrors) {
    setTimeout(() => {
      if (typeof setCurrentTabKey === 'function') {
        setCurrentTabKey(formWithErrors.parentTabKey);
      }
    });
  }
};

export const percepcionesPermission = {
  permissionModel: 'percepcion',
  catalogsModels: [
    'tipodecontratacion',
  ],
  tabsModels: [],
};

const { Text } = Typography;

const complexForms = [];

const Percepcion = ({ permission }) => {
  const [form] = Form.useForm();
  const [formParametrizacion] = Form.useForm();
  const [formAsignacion] = Form.useForm();
  const [formRegistro] = Form.useForm();
  const [formFijo] = Form.useForm();
  const [formVariable] = Form.useForm();
  const [formOtrosParametros] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [extraTabKey, setExtraTabKey] = useState('fijo');
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [mutable, setMutable] = useState(true);
  const [estados, setEstados] = useState([]);
  const [periodicidadPercepciones, setPeriodicidadPercepciones] = useState([]);
  const [cogs, setCogs] = useState([]);
  const [tipoDeGasto, setTipoDeGasto] = useState([]);
  const [fuentesFinanciamiento, setFuentesFinanciamiento] = useState([]);
  const [cuentasContables, setCuentasContables] = useState([]);
  const [catsatPercepciones, setCatsatPercepciones] = useState([]);
  const [catsatOrigenes, setCatsatOrigenes] = useState([]);
  const [afectaPresupuesto, setAfectaPresupuesto] = useState(false);
  const [aplicaImporteFijo, setAplicaImporteFijo] = useState(false);
  const [aplicaDiasFijo, setAplicaDiasFijo] = useState(false);
  const [aplicaImporteMensual, setAplicaImporteMensual] = useState(false);
  const [aplicaImporteEvento, setAplicaImporteEvento] = useState(false);
  const [esImporteFijo, setEsImporteFijo] = useState(true);
  const [aplicaPagoHora, setAplicaPagoHora] = useState(false);
  const [aplicaPagoDia, setAplicaPagoDia] = useState(false);
  const [aplicaPorcentajePercepcion, setAplicaPorcentajePercepcion] = useState(false);
  const [fechaAlta, setFechaAlta] = useState({});
  const [aplicaAntiguedad, setAplicaAntiguedad] = useState(false);
  const [aplicaDiasPorcentaje, setAplicaDiasPorcentaje] = useState(false);
  const [aplicaImporteVariableEvento, setAplicaImporteVariableEvento] = useState(false);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [confirmationCancelarVisible, setConfirmationCancelarVisible] = useState(false);
  const [confirmationReactivarVisible, setConfirmationReactivarVisible] = useState(false);
  const [confirmationVisibleEstatus, setConfirmationVisibleEstatus] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [simpleData, setSimpleData] = useState([]);
  const [PagosInformativosSAT, setPagosInformativosSAT] = useState([]);
  const [aplicaImporteFijoPeriodo, setAplicaImporteFijoPeriodo] = useState(false);
  const [aplicaImporteFijoAnual, setAplicaImporteFijoAnual] = useState(false);
  const [otrosTiposPagoNominas, setOtrosTiposPagoNominas] = useState([]);
  const [mostrarPagoInformativo, setMostrarPagoInformativo] = useState(false);
  const [mostrarFechaFija, setMostrarFechaFija] = useState(false);
  const [esReembolsoDescuentoIndebido, setEsReembolsoDescuentoIndebido] = useState(false);
  const [esPagoDescuentoIndebido, setEsPagoDescuentoIndebido] = useState(false);
  const [idsSeleccionados, setIdsSeleccionados] = useState([]);
  const [selectedPercepcion, setSelectedPercepcion] = useState(null);
  const [mostrarRegistrosContables, setMostrarRegistrosContables] = useState(false);
  const [tipoEmpleadoPreseleccionado, setTipoEmpleadoPreseleccionado] = useState(null);
  const [aplicaLimiteSueldo, setAplicaLimiteSueldo] = useState(false);
  const [aplicaTipoEmpleado, setAplicaTipoEmpleado] = useState(false);
  const [aplicaExclusionTipoEmpleado, setAplicaExclusionTipoEmpleado] = useState(false);
  const [aplicaAntiguedadMinima, setAplicaAntiguedadMinima] = useState(false);
  // const [apareceEnPlazas, setApareceEnPlazas] = useState(false);
  const [aplicaImportePlaza, setAplicaImportePlaza] = useState(false);
  // const [aplicaIncidenciasReloj, setAplicaIncidenciasReloj] = useState(false);
  // const [aplicaImportePuesto, setAplicaImportePuesto] = useState(false);
  const [aplicaSindicalizados, setAplicaSindicalizados] = useState(false);
  const [aplicaAntiguedadEmpleado, setAplicaAntiguedadEmpleado] = useState(false);
  const [aplicaProporcionDias, setAplicaProporcionDias] = useState(false);
  const [tiposEmpleados, setTiposEmpleados] = useState([]);
  const [directoriosExternos, setDirectoriosExternos] = useState([]);
  const [formasDePago, setFormasDePago] = useState([]);
  const [descuentos, setDescuentos] = useState([]);
  const [tiposEmpleadoPresupuestales, setTiposEmpleadoPresupuestales] = useState([]);
  const [fuentesFinanciamientoFlat, setFuentesFinanciamientoFlat] = useState([]);
  const nameAplicaFechas = 'aplica_rangos_de_fechas';
  const nameAplicaNumeroDias = 'aplica_numero_dias_de_pago';
  const nameAplicaIncidenciasReloj = 'aplica_incidencias_de_reloj_checador';
  const nameAreaComision = 'aplica_area_de_comision';
  const apareceEnPlazas = Form.useWatch('aparece_en_plazas', formParametrizacion);
  const aplicaIncidenciasReloj = Form.useWatch(nameAplicaIncidenciasReloj, formOtrosParametros);
  const aplicaImportePuesto = Form.useWatch('aplica_importe_por_puesto', formOtrosParametros);

  const baseURI = 'nominas/percepciones';
  const baseURIExtra = 'nominas/percepciones-parametros-diversos';
  const requiredFormStructure = [
    {
      parentTabKey: 'general',
      tabFields: ['clave', 'descripcion', 'fecha_de_alta', 'fecha_de_baja', 'es_percepcion_importe_fijo'],
    },
    {
      parentTabKey: 'parametrizacion',
      tabFields: ['aparece_en_tabulador', 'es_solicitable', 'es_recurrente', 'es_incidencia', 'es_percepcion_fija_para_isr', 'es_sueldo', 'genera_descuento'],
    },
    {
      parentTabKey: 'asignacion',
      tabFields: ['periodicidad_de_percepcion'],
    },
    {
      parentTabKey: 'registro',
      tabFields: ['afecta_presupuesto', 'forma_de_pago', 'tipo_de_gasto', 'fuente_financiamiento', 'cuenta_contable', 'catsat_percepcion', 'catsat_origen_recurso'],
    },
    {
      parentTabKey: 'otrosParametros',
      tabFields: [
        'tiene_limite_maximo_sueldo',
        'fecha_inicial', 'fecha_final', 'numero_dias_de_pago',
        [nameAplicaFechas], [nameAplicaNumeroDias], [nameAreaComision],
        'aplica_tipo_empleados', 'tipo_empleado',
        'aplica_antiguedad_minima', 'antiguedad_minima',
        'aparece_en_plazas', 'aplica_incidencias_reloj_checador',
        'aplica_importe_por_puesto', 'aplica_sindicalizado',
        'aplica_antiguedad_del_empleado', 'aplica_proporcion_dias_laborados',
      ],
    },
    {
      parentTabKey: 'importe',
      tabFields: [
        'aplica_importe_diario_fijo', 'importe_diario', 'aplica_dias_laborados', 'aplica_importe_mensual', 'importe_mensual',
        'aplica_importe_fijo_por_evento', 'importe_fijo_por_evento', 'aplica_no_de_dias_laborados', 'aplica_salario_diario_tabular',
        'aplica_salario_diario_nominal', 'aplica_pago_por_hora', 'aplica_pago_por_dia', 'aplica_antiguedad_laboral',
        'aplica_no_de_dias_porcentaje', 'formula', 'aplica_importe_fijo_por_periodo_de_nomina', 'importe_fijo_por_periodo_de_nomina',
        'aplica_importe_fijo_anual', 'importe_fijo_anual', 'aplica_importe_variable_por_parametro',
      ],
    },
  ];
  const basicKeys = [
    'general',
    'parametrizacion',
    'asignacion',
    'registro',
    'importe',
    'otrosParametros',
  ];

  const extraKeys = [
    'fijo',
    'variable',
  ];

  const getPermission = getModelPermission(
    percepcionClaseDeContratacionPermission.permissionModel,
    percepcionClaseDeContratacionPermission.catalogsModels,
    percepcionClaseDeContratacionPermission.tabsModels,
    false,
  );

  const getPermissionAntiguedad = getModelPermission(
    percepcionConfiguracionAntiguedadPermission.permissionModel,
    percepcionConfiguracionAntiguedadPermission.catalogsModels,
    percepcionConfiguracionAntiguedadPermission.tabsModels,
    false,
  );

  const getPermissionNomina = getModelPermission(
    percepcionTipoNominaPermission.permissionModel,
    percepcionTipoNominaPermission.catalogsModels,
    percepcionTipoNominaPermission.tabsModels,
    false,
  );

  const getPermissionNominaEmpleado = getModelPermission(
    percepcionTipoNominaEmpleadoPermission.permissionModel,
    percepcionTipoNominaEmpleadoPermission.catalogsModels,
    percepcionTipoNominaEmpleadoPermission.tabsModels,
    false,
  );

  const onClickTitle = (e) => {
    const element = e.target;
    if (element) {
      let parent = element.parentElement;
      parent = parent ? parent.parentElement : null;
      if (parent) {
        const clickableSpan = parent.previousSibling;
        if (clickableSpan) {
          clickableSpan.click();
        }
      }
    }
  };
  const buildTreeData = (_data) => {
    const map = {};
    const roots = [];

    data.forEach((item) => {
      map[item.id] = {
        title: `${item.clave} - ${item.concepto}`,
        value: item.clave_padre_id ? `${data.find((x) => x.id === item.clave_padre_id)?.clave}/${item.id}` : `${item.id}`,
        key: item.clave_padre_id ? `${data.find((x) => x.id === item.clave_padre_id)?.clave}/${item.id}` : `${item.id}`,
        children: [],
        ...item,
      };
    });

    data.forEach((item) => {
      if (item.clave_padre_id && map[item.clave_padre_id]) {
        map[item.clave_padre_id].children.push(map[item.id]);
      } else {
        roots.push(map[item.id]);
      }
    });

    return roots;
  };
  // Extrae solo el ID del valor "clave/id"
  const getCogId = (val) => Number(String(val).split('/').pop());

  // Encuentra el .value del nodo del árbol dado un ID
  const getTreeValueById = (tree, id) => {
    const stack = [...tree];
    while (stack.length) {
      const node = stack.pop();
      if (getCogId(node?.value) === id) return node.value;
      if (node.children?.length) stack.push(...node.children);
    }
    return undefined;
  };

  const renderTitle = (title, bold) => (
    // eslint-disable-next-line
    <span onClick={onClickTitle} className={bold ? 'bold' : ''}>
      {title}
    </span>
  );

  const normalizeCuentasContables = (_data) => {
    if (_data) {
      return _data.map((item) => {
        const clone = { ...item };
        const children = normalizeCuentasContables(clone.children);

        //  Solo es seleccionable si es tipo === 7 (afectable)
        const isAfectable = clone.tipo === 7;

        // Si no tiene hijos, lo evaluamos como hoja
        const isLeaf = !children.length;

        //  Solo habilitamos selección si es hoja y afectable
        const selectable = isLeaf && isAfectable;

        if (!isLeaf) {
          delete clone.children;
        }

        return {
          ...clone,
          title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
          value: clone.id,
          key: clone.id,
          children: children.length ? children : undefined,
          disabled: !selectable, //  Solo se puede seleccionar si cumple la condición
        };
      });
    }
    return [];
  };

  // const calcularProfundidadMaxima = (arreglo) => {
  //   let maxProfundidad = 0;
  //   const calcularProfundidadRecursiva = (nodo, profundidad) => {
  //     maxProfundidad = Math.max(maxProfundidad, profundidad);
  //     if (!nodo.children || nodo.children.length === 0) {
  //       return;
  //     }
  //     nodo.children.forEach((hijo) => {
  //       calcularProfundidadRecursiva(hijo, profundidad + 1);
  //     });
  //   };
  //   arreglo.forEach((nodo) => {
  //     calcularProfundidadRecursiva(nodo, 1);
  //   });
  //   return maxProfundidad;
  // };

  // const agregarDisabledEnNivelMasProfundo = (arreglo) => {
  //   const profundidadMaxima = calcularProfundidadMaxima(arreglo);
  //   const agregarDisabledRecursivo = (nodo, profundidadActual) => {
  //     if (!nodo.children || nodo.children.length === 0) {
  //       if (profundidadActual === profundidadMaxima) {
  //         if (nodo?.tipo === 7) {
  //           // eslint-disable-next-line no-param-reassign
  //           nodo.disabled = false;
  //         } else {
  //           // eslint-disable-next-line no-param-reassign
  //           nodo.disabled = true;
  //         }
  //         return;
  //       }
  //       // eslint-disable-next-line no-param-reassign
  //       nodo.disabled = true;
  //       return;
  //     }
  //     if (profundidadActual === profundidadMaxima) {
  //       // eslint-disable-next-line no-param-reassign
  //       nodo.disabled = false;
  //     } else {
  //       // eslint-disable-next-line no-param-reassign
  //       nodo.disabled = true;
  //     }
  //     nodo.children.forEach((hijo) => {
  //       agregarDisabledRecursivo(hijo, profundidadActual + 1);
  //     });
  //   };
  //   arreglo.forEach((nodo) => {
  //     agregarDisabledRecursivo(nodo, 1);
  //   });
  // };

  const normalizeTreeCog = (_data) => {
    const newData = {};

    _data.forEach((item) => {
      const clone = { ...item };
      const title = `${clone.clave} - ${clone.concepto}`;
      clone.title = renderTitle(title);
      clone.key = clone.id;
      clone.value = clone.id;

      if (clone.clave_padre_id) {
        const padre = newData[clone.clave_padre_id];
        if (padre) {
          clone.key = `${padre.clave}/${clone.id}`;
          clone.value = `${padre.clave}/${clone.id}`;
          padre.children = padre.children || [];
          padre.children.push(clone);
        }
      }

      //  Evita sobrescribir `seleccionable` con lógica de hijos
      clone.disabled = clone.seleccionable === false; //  aquí desactiva nodos con seleccionable: false

      if (!newData[clone.id]) {
        newData[clone.id] = clone;
        clone.children = clone.children || undefined;
      }
    });

    const capitulosCog = Object.values(newData).filter((item) => !item.clave_padre_id);
    return capitulosCog;
  };

  const findInTreeCuentasContables = (nodes, id) => {
    if (!Array.isArray(nodes)) return null;

    return nodes.reduce((found, node) => {
      if (found) return found;

      if (node.id === id) {
        return node;
      }

      if (node.children) {
        return findInTreeCuentasContables(node.children, id) || found;
      }

      return found;
    }, null);
  };

  const disableNivel4Nodes = (nodes, nivel = 1) => nodes.map((node) => {
    const newNode = { ...node };
    if (nivel === 4) {
      newNode.disabled = true;
    }
    if (newNode.children) {
      newNode.children = disableNivel4Nodes(newNode.children, nivel + 1);
    }
    return newNode;
  });
  const normalizeSimpleData = (_data) => {
    const result = [];
    const processNode = (node) => {
      const copy = { ...node };
      result.push(copy);
      if (copy.children && copy.children.length) {
        copy.children.forEach((child) => {
          processNode(child);
        });
      }
      copy.children = undefined;
    };
    _data.forEach(processNode);
    return result;
  };

  const normalize = (_data = [], level = 0, visited = new Set()) => _data.map((item, index) => {
    const clone = { ...item };
    const uniqueId = clone.id ?? clone.clave;

    if (visited.has(uniqueId)) {
      return null;
    }

    visited.add(uniqueId);

    const children = Array.isArray(clone.children)
      ? normalize(clone.children, level + 1, new Set(visited))
      : [];

    return {
      ...clone,
      key: clone.id,
      value: clone.id,
      title: renderTitle(`${clone.clave} - ${clone.nombre}`, children.length > 0),
      disabled: item.seleccionable === false,
      children: children.length ? children : undefined,
    };
  }).filter(Boolean);

  const formatDataTree = (_data = [], excludeLvl3 = false, currLvl = 1) => _data.map((item) => {
    const clone = { ...item };

    const children = formatDataTree(
      !excludeLvl3 || currLvl !== 2 ? clone.children || [] : [],
      excludeLvl3,
      currLvl + 1,
    );

    const node = {
      key: clone.key || clone.id?.toString(),
      value: clone.value || clone.id?.toString(),
      title: clone.title,
      disabled: !clone.seleccionable,
      children, // mantener siempre
    };

    return node;
  });

  const fetchData = async () => {
    setLoading(true);
    const _data = await getPercepciones();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _otrosTiposPagoNominas,
        _PagosInformativosSAT,
        _estados,
        _periodicidadPercepciones,
        _cogs,
        _tipoDeGasto,
        // eslint-disable-next-line no-unused-vars
        _fuentesFinanciamiento,
        _cuentasContables,
        _catsat_percepciones,
        _catsat_origenes,
        // eslint-disable-next-line no-unused-vars
        _clasificacionesObjetosGasto,
        _data,
        _dataUnion,
        _tiposEmpleados,
        _areasExternas,
        _formasDePago,
        _descuentos,
        _tiposEmpleadoPresupuestales,
      ] = await Promise.all([
        getOtrosTiposDePagoNomina(),
        getPagosInformativosSAT(),
        getEstadosGlobales(),
        getPeriodicidadDePercepciones({ estados_globales: ESTATUS_AUTORIZADO }),
        getCOGS(),
        getTipoDeGasto(),
        getFuentesDeFinanciamiento(),
        getCuentasContables(),
        getCATSATPercepciones(),
        getCATSATOrigenesRecursos(),
        getClasificadoresObjetosGasto(),
        getPercepciones(),
        getClasificadoresObjetoGastoUnion(),
        getTiposDeEmpleados(),
        getAreasExternas(),
        getMetodosDePagos(),
        getConfiguracionDescuentos(),
        getTiposDeEmpleadosPresupuestales(),
      ]);
      const formattedDataUnion = normalizeTreeCog(_dataUnion);
      // const formattedDataUnionWithDisabled = disableNivel4Nodes(formattedDataUnion);
      const _simpleData = normalizeSimpleData(formattedDataUnion);
      if (mounted) {
        const tieneAplicacionPorArea = _data.some(
          (item) => item.aplica_cuenta_contable_por_area === true,
        );
        setTiposEmpleados(_tiposEmpleados);
        setFormasDePago(_formasDePago);
        setMostrarRegistrosContables(tieneAplicacionPorArea);
        setOtrosTiposPagoNominas(_otrosTiposPagoNominas);
        setPagosInformativosSAT(_PagosInformativosSAT);
        setTreeData(formattedDataUnion);
        setSimpleData(_simpleData);
        const response = await API.get('contabilidad/clasificaciones-de-fuentes-de-financiamiento/');
        const fuentesFTree = makeTree(response.data);
        const normalized = normalize(fuentesFTree);
        setFuentesFinanciamiento(formatDataTree(normalized));
        setFuentesFinanciamientoFlat(response.data);
        setTiposEmpleadoPresupuestales(_tiposEmpleadoPresupuestales);
        setEstados(_estados);
        setPeriodicidadPercepciones(_periodicidadPercepciones);
        setCogs(_cogs);
        setTipoDeGasto(_tipoDeGasto);
        // const sortedFDF = _fuentesFinanciamiento.sort((a, b) => a.id - b.id);
        // setFuentesFinanciamiento(normalizeFDF(sortedFDF));
        const normalizedCuentas = normalizeCuentasContables(makeTreeCuentasContable(_cuentasContables));
        setCuentasContables(normalizedCuentas);
        setCatsatPercepciones(_catsat_percepciones);
        setCatsatOrigenes(_catsat_origenes);
        setDirectoriosExternos(_areasExternas);
        setDescuentos(_descuentos);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const valor = formParametrizacion.getFieldValue('es_reembolso_de_descuento_indebido');
    setEsReembolsoDescuentoIndebido(valor === true);

    const pagoInfoId = formParametrizacion.getFieldValue('pago_informativo_para_sat');
    const pagosArr = PagosInformativosSAT?.results || PagosInformativosSAT || [];
    const pagoItem = pagosArr.find((p) => p.id === pagoInfoId);
    setEsPagoDescuentoIndebido(
      (pagoItem?.descripcion || '').toUpperCase().trim() === 'ES PAGO DE DESCUENTO INDEBIDO',
    );
  }, [open, PagosInformativosSAT]); // Cada vez que se abre el formulario

  const onCancel = () => {
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setConfirmationCancelarVisible(false);
    setConfirmationReactivarVisible(false);
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
    formParametrizacion.resetFields();
    formAsignacion.resetFields();
    formRegistro.resetFields();
    formFijo.resetFields();
    formOtrosParametros.resetFields();
    formVariable.resetFields();
    setMutable(true);
    setExtraTabKey('fijo');
    setCurrentTabKey('general');
    setAplicaAntiguedad(false);
    setAplicaDiasPorcentaje(false);
    setEsImporteFijo(true);
    setAplicaImporteFijo(false);
    setAplicaDiasFijo(false);
    setAplicaImporteEvento(false);
    setAplicaImporteMensual(false);
    setAfectaPresupuesto(false);
    setAplicaPagoDia(false);
    setAplicaPagoHora(false);
    setAplicaPorcentajePercepcion(false);
    setAplicaImporteVariableEvento(false);
    setMostrarRegistrosContables(false);
    setTipoEmpleadoPreseleccionado(null);
    setAplicaImportePlaza(false);
    // setAplicaIncidenciasReloj(false);
    // setAplicaImportePuesto(false);
    setAplicaSindicalizados(false);
    setAplicaAntiguedadEmpleado(false);
    setAplicaProporcionDias(false);
    setAplicaImporteFijoPeriodo(false);
    setAplicaImporteFijoAnual(false);
    setAplicaLimiteSueldo(false);
    setAplicaTipoEmpleado(false);
    setAplicaExclusionTipoEmpleado(false);
    setAplicaAntiguedadMinima(false);
    setAplicaLimiteSueldo(false);
    setEsPagoDescuentoIndebido(false);
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _percepcion = await getPercepcion(match.id);

    if (_percepcion?.estados_globales === ESTATUS_ACTIVO || _percepcion?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter(
        (estado) => estado?.id === ESTATUS_INACTIVO || estado?.id === ESTATUS_ACTIVO,
      ));
    }

    if (_percepcion?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }

    if (_percepcion?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }

    setTimeout(() => {
      if (_percepcion) {
        form.resetFields();
        formParametrizacion.resetFields();
        formAsignacion.resetFields();
        formRegistro.resetFields();
        formFijo.resetFields();
        formVariable.resetFields();
        formOtrosParametros.resetFields();

        setTimeout(() => {
          const tieneAplicaCuenta = _percepcion.parametros_diversos?.some(
            (param) => param.aplica_cuenta_contable_por_area === true,
          );

          // Actualizamos el estado del padre directamente
          setMostrarRegistrosContables(tieneAplicaCuenta);
          // TRANSFORMAR ID numérico → valor visual del TreeSelect (clave_padre/ID)
          const cogId = _percepcion?.cog;
          let cogValueFormatted = null;

          if (cogId) {
            //  Filtrar solo por seleccionable: true
            const cogItem = simpleData.find((e) => e.id === cogId && e.seleccionable === true);
            const padre = simpleData.find((e) => e.id === cogItem?.clave_padre_id);
            cogValueFormatted = padre ? `${padre.clave}/${cogItem.id}` : cogItem?.id?.toString();
          }

          const registroConVisualCOG = {
            ...formatReceived(_percepcion),
            cog: cogValueFormatted,
          };

          form.setFieldsValue(formatReceived(_percepcion));
          formParametrizacion.setFieldsValue(formatReceived(_percepcion));
          formAsignacion.setFieldsValue(formatReceived(_percepcion));
          formRegistro.setFieldsValue(registroConVisualCOG);
          formFijo.setFieldsValue(formatReceived(_percepcion));
          formVariable.setFieldsValue(formatReceived(_percepcion));
          formOtrosParametros.setFieldsValue(formatReceived(_percepcion));

          // Plazas
          // const tienePlazas = _percepcion.aparece_en_plazas === true;
          // setApareceEnPlazas(tienePlazas);

          const tieneImportePlaza = _percepcion.aplica_importe_por_plaza === true;
          setAplicaImportePlaza(tieneImportePlaza);

          // Puesto
          // const tienePuesto = _percepcion.aplica_importe_por_puesto === true;
          // setAplicaImportePuesto(tienePuesto);

          // Incidencias (Ojo con el nombre de la API: lleva "_de_")
          // const tieneIncidencias = _percepcion.aplica_incidencias_de_reloj_checador === true;
          // setAplicaIncidenciasReloj(tieneIncidencias);

          setAplicaLimiteSueldo(_percepcion.tiene_limite_maximo_sueldo === true);
          setAplicaTipoEmpleado(_percepcion.aplica_tipo_de_empleados === true);
          setAplicaExclusionTipoEmpleado(_percepcion.aplica_exclusion_por_tipo_de_empleados === true);
          setAplicaAntiguedadMinima(_percepcion.aplica_antiguedad_minima === true);
          setAplicaLimiteSueldo(_percepcion.tiene_limite_maximo_sueldo === true);

          // Otros ajustes visuales
          setVisible(true);
          setMostrarFechaFija(_percepcion.es_percepcion_con_fecha_fija_de_pago === true);
          setEsImporteFijo(form.getFieldValue('es_percepcion_importe_fijo'));
          form.getFieldValue('es_percepcion_importe_fijo') ? setExtraTabKey('fijo') : setExtraTabKey('variable');
          setAplicaImporteFijo(formFijo.getFieldValue('aplica_importe_diario_fijo'));
          setAplicaDiasFijo(formFijo.getFieldValue('aplica_no_dias_fijos'));
          setAplicaImporteEvento(_percepcion?.aplica_importe_fijo_por_evento);
          setAplicaImporteMensual(_percepcion?.aplica_importe_mensual);
          setAfectaPresupuesto(formRegistro.getFieldValue('afecta_presupuesto'));
          setAplicaPagoDia(formRegistro.getFieldValue('aplica_pago_por_dia'));
          setAplicaPagoHora(formRegistro.getFieldValue('aplica_pago_por_hora'));
          setAplicaPorcentajePercepcion(formRegistro.getFieldValue('aplica_porcentaje_unico_de_percepcion'));
          setAplicaAntiguedad(_percepcion?.aplica_antiguedad_laboral);
          setAplicaDiasPorcentaje(_percepcion?.aplica_no_de_dias_porcentaje);
          setAplicaImporteVariableEvento(_percepcion?.aplica_importe_variable_por_evento);
          setAplicaImporteFijoPeriodo(_percepcion?.aplica_importe_fijo_por_periodo_de_nomina);
          setAplicaImporteFijoAnual(_percepcion?.aplica_importe_fijo_anual);
        });
      }
    });

    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);

      // 1. Validación de todos los formularios
      await form.validateFields();
      await formParametrizacion.validateFields();
      await formAsignacion.validateFields();
      await formRegistro.validateFields();
      await formFijo.validateFields();
      await formVariable.validateFields();
      await formOtrosParametros.validateFields();

      // 2. Consolidación de valores
      const values = {
        ...form.getFieldsValue(),
        ...formParametrizacion.getFieldsValue(),
        ...formAsignacion.getFieldsValue(),
        ...formRegistro.getFieldsValue(),
        ...formFijo.getFieldsValue(),
        ...formVariable.getFieldsValue(),
        ...formOtrosParametros.getFieldsValue(),
      };

      // 3. Transformación del COG (extrae el ID del valor "1100/3" → 3)
      if (values.cog) {
        values.cog = getCogId(values.cog);
      }

      // --- 4. SANITIZACIÓN ROBUSTA DE ARREGLOS Y NULOS ---

      // Limpieza general de strings vacíos
      Object.keys(values).forEach((key) => {
        if (values[key] === '') {
          values[key] = null;
        }
      });

      // C. Un Select limpiado (allowClear) deja el valor en `undefined`, y el
      // cliente API descarta esas claves al armar la petición, por lo que un
      // PATCH nunca llegaría a limpiar el campo en el backend. Se normaliza a
      // `null` para que sí se limpie.
      if (values.descuento_que_se_aplica === undefined) {
        values.descuento_que_se_aplica = null;
      }
      // ---------------------------------------------------

      // 5. Petición al API
      const [key] = selectedRowKeys;
      const saved = key
        ? await patchPercepcion(key, values)
        : await postPercepcion(values);

      // 6. Acciones post-guardado
      if (saved) {
        // Vuelve a poner el valor visual en el TreeSelect después de guardar
        const visualValue = getTreeValueById(treeData, saved.cog);
        formRegistro.setFieldValue('cog', visualValue);

        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }

      setLoading(false);
    } catch (err) {
      // 7. Manejo de Errores
      if (err.errorFields) {
        onErrorFields(err, setLoading, requiredFormStructure, setCurrentTabKey);
        message.warn('Favor de corregir los errores señalados');
      } else {
        onError(err, setLoading);
      }
    }
  };

  const handleParametroDiversoSeleccionado = (record) => {
    if (record && record.tipo_empleado_presupuestal) {
      setTipoEmpleadoPreseleccionado(record.tipo_empleado_presupuestal);
    } else {
      setTipoEmpleadoPreseleccionado(null);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deletePercepcion(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const res = await API.patch(`/nominas/autorizar-percepciones/${selectedRowKeys[0]}`);
      res.data;
      if (res) {
        onSuccess(res, 'Autorizado correctamente');
        await fetchData();
        setConfirmationVisible(false);
      }
    } catch (err) {
      onError(err, setLoading);
    }
    return setLoading(false);
  };

  const handleOnFinishCancelar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const res = await patchPercepcion(key, { estados_globales: ESTATUS_CANCELADO });
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationCancelarVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishReactivar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        return;
      }
      const res = await patchPercepcion(key, { estados_globales: ESTATUS_ACTIVO });
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationReactivarVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    setConfirmationVisibleEstatus(false);
  };
  const columnsParametrizacion = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
  ];

  const verificarRegistrosContables = (datosTablaHijo) => {
    if (Array.isArray(datosTablaHijo)) {
      const mostrar = datosTablaHijo.some((item) => item.aplica_cuenta_contable_por_area === true);
      setMostrarRegistrosContables(mostrar);
    }
  };

  const columns = [
    {
      titleText: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Clave Anterior',
      dataIndex: 'clave_anterior',
      key: 'clave_anterior',
      width: 200,
    },
    {
      titleText: 'Percepción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 300,
    },
    {
      titleText: 'Periodicidad de Percepción',
      dataIndex: 'periodicidad_de_percepcion',
      key: 'periodicidad_de_percepcion',
      width: 300,
      render: (val) => periodicidadPercepciones.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Tabulable',
      dataIndex: 'aparece_en_tabulador',
      key: 'aparece_en_tabulador',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Solicitable',
      dataIndex: 'es_solicitable',
      key: 'es_solicitable',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Es Incidencia',
      dataIndex: 'es_incidencia',
      key: 'es_incidencia',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Es Finiquito',
      dataIndex: 'es_percepcion_de_finiquito',
      key: 'es_percepcion_de_finiquito',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Es Indemnización',
      dataIndex: 'es_percepcion_de_indemnizacion',
      key: 'es_percepcion_de_indemnizacion',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'COG',
      dataIndex: 'cog',
      key: 'cog',
      width: 400,
      render: (val) => {
        const _cogs = cogs.find((e) => e.id === val);
        return (_cogs?.clave ? `${_cogs?.clave} - ${_cogs?.concepto}` : '');
      },
    },
    {
      titleText: 'Tipo de Gasto',
      dataIndex: 'tipo_de_gasto',
      key: 'tipo_de_gasto',
      width: 400,
      render: (val) => {
        const _tipoDeGasto = tipoDeGasto.find((e) => e.id === val);
        return (_tipoDeGasto?.clave ? `${_tipoDeGasto?.clave} - ${_tipoDeGasto?.nombre}` : '');
      },
    },
    {
      titleText: 'Fuente Financiamiento',
      dataIndex: 'fuente_financiamiento',
      key: 'fuente_financiamiento',
      width: 200,
      render: (val) => {
        const _fuentesFinanciamiento = fuentesFinanciamiento.find((e) => e.id === val);
        return (_fuentesFinanciamiento?.clave ? `${_fuentesFinanciamiento?.clave} - ${_fuentesFinanciamiento?.nombre}` : '');
      },
    },
    {
      titleText: 'Cuenta Contable',
      dataIndex: 'cuenta_contable',
      key: 'cuenta_contable',
      width: 400,
      render: (val) => {
        const _cuentasContables = cuentasContables.find((e) => e.id === val);
        return `${_cuentasContables?.clave_visible || _cuentasContables?.clave} - ${_cuentasContables?.nombre}`;
      },
    },
    {
      titleText: 'Percepción del SAT',
      dataIndex: 'catsat_percepcion',
      key: 'catsat_percepcion',
      width: 200,
      render: (val) => {
        const _catsatPercepciones = catsatPercepciones.find((e) => e.id === val);
        return `${_catsatPercepciones?.clave} - ${_catsatPercepciones?.descripcion}`;
      },
    },
    {
      titleText: 'Origen del Recurso del SAT',
      dataIndex: 'catsat_origen_recurso',
      key: 'catsat_origen_recurso',
      width: 250,
      render: (val) => catsatOrigenes.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
    valor: [
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
    dias: [
      requiredRule,
      {
        pattern: integerRegExp,
        message: 'Ingrese un valor válido',
      },
    ],
    fecha_valida: [
      {
        validator: async (rule, value) => {
          if (value) {
            if (fechaAlta > value) {
              throw new Error('La fecha inicial debe ser menor que la final');
            }
          }
        },
      },
    ],
    porcentaje: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
      {
        validator: async (rule, value) => {
          if (value > 100) {
            throw new Error('Este campo no puede ser mayor a 100%');
          }
        },
      },
    ],
  };

  const showMsg = makeMessager(setCurrentTabKey);

  const showMsgExtra = makeMessager(setExtraTabKey);

  const onChangeTabKey = makeOnChangeTabKey(
    basicKeys,
    complexForms,
    currentTabKey,
    setCurrentTabKey,
    showMsg,
  );

  const onChangeTabKeyExtra = makeOnChangeTabKey(
    extraKeys,
    complexForms,
    extraTabKey,
    setExtraTabKey,
    showMsgExtra,
  );

  const disableVariante = (changedValues) => {
    if (changedValues.aplica_importe_diario_fijo !== undefined) {
      changedValues.aplica_importe_diario_fijo ? setAplicaImporteFijo(true)
        : (setAplicaImporteFijo(false), formFijo.resetFields(['importe_diario']));
    }

    if (changedValues.aplica_no_dias_fijos !== undefined) {
      changedValues.aplica_no_dias_fijos ? setAplicaDiasFijo(true)
        : (setAplicaDiasFijo(false), formFijo.resetFields(['no_dias_fijos']));
    }

    if (changedValues.aplica_importe_mensual !== undefined) {
      changedValues.aplica_importe_mensual ? setAplicaImporteMensual(true)
        : (setAplicaImporteMensual(false), formFijo.resetFields(['importe_mensual']));
    }

    if (changedValues.aplica_importe_fijo_por_evento !== undefined) {
      changedValues.aplica_importe_fijo_por_evento ? setAplicaImporteEvento(true)
        : (setAplicaImporteEvento(false), formFijo.resetFields(['importe_fijo_por_evento']));
    }

    if (changedValues.aplica_importe_fijo_por_periodo_de_nomina !== undefined) {
      changedValues.aplica_importe_fijo_por_periodo_de_nomina ? setAplicaImporteFijoPeriodo(true)
        : (setAplicaImporteFijoPeriodo(false), formFijo.resetFields(['importe_fijo_por_periodo_de_nomina']));
    }

    if (changedValues.aplica_importe_fijo_anual !== undefined) {
      changedValues.aplica_importe_fijo_anual ? setAplicaImporteFijoAnual(true)
        : (setAplicaImporteFijoAnual(false), formFijo.resetFields(['importe_fijo_anual']));
    }
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            cols={columns}
            data={data}
            titleTable="Percepciones"
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            customDataArbolado={simpleData}
            allowExtraImport
            asyncImportExtra
            baseURIExtra={baseURIExtra}
            labelExtraImport="Elementos Presupuestales y Cuentas Contables"
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            disableDelete={
              data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
            }
            customActions={[
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'percepcion', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
              {
                onClick: () => setConfirmationCancelarVisible(true),
                permission: { model: 'percepcion', action: 'cancelar' },
                text: 'Cancelar',
                icon: <CloseCircleOutlined />,
                disabledBySelection: false,
                className: 'cancel',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO,
              },
              {
                onClick: () => setConfirmationReactivarVisible(true),
                permission: { model: 'percepcion', action: 'reactivar' },
                text: 'Reactivar',
                icon: <RedoOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_ACTIVO,
              },
            ]}
            permission={permission}
            allowImport
            allowExportPDF={false}
            baseURI={baseURI}
            onExportExcel={async () => {
              // Función personalizada para exportar Excel con el campo ID
              const exportData = data.map((item) => ({
                ID: item.id || '',
                Clave: item.clave || '',
                'Clave Anterior': item.clave_anterior || '',
                Percepción: item.descripcion || '',
                'Periodicidad de Percepción': periodicidadPercepciones.find((e) => e.id === item.periodicidad_de_percepcion)?.descripcion || '',
                Tabulable: item.aparece_en_tabulador ? 'Si' : 'No',
                Solicitable: item.es_solicitable ? 'Si' : 'No',
                'Es Incidencia': item.es_incidencia ? 'Si' : 'No',
                'Es Finiquito': item.es_percepcion_de_finiquito ? 'Si' : 'No',
                'Es Indemnización': item.es_percepcion_de_indemnizacion ? 'Si' : 'No',
                COG: (() => {
                  const _cogs = cogs.find((e) => e.id === item.cog);
                  return _cogs?.clave ? `${_cogs.clave} - ${_cogs.concepto}` : '';
                })(),
                'Tipo de Gasto': (() => {
                  const _tipoDeGasto = tipoDeGasto.find((e) => e.id === item.tipo_de_gasto);
                  return _tipoDeGasto?.clave ? `${_tipoDeGasto.clave} - ${_tipoDeGasto.nombre}` : '';
                })(),
                'Fuente Financiamiento': (() => {
                  const _fuentesFinanciamiento = fuentesFinanciamiento.find((e) => e.id === item.fuente_financiamiento);
                  return _fuentesFinanciamiento?.clave ? `${_fuentesFinanciamiento.clave} - ${_fuentesFinanciamiento.nombre}` : '';
                })(),
                'Cuenta Contable': (() => {
                  const _cuentasContables = cuentasContables.find((e) => e.id === item.cuenta_contable);
                  return _cuentasContables ? `${_cuentasContables.clave_visible || _cuentasContables.clave} - ${_cuentasContables.nombre}` : '';
                })(),
                'Percepción del SAT': (() => {
                  const _catsatPercepciones = catsatPercepciones.find((e) => e.id === item.catsat_percepcion);
                  return _catsatPercepciones ? `${_catsatPercepciones.clave} - ${_catsatPercepciones.descripcion}` : '';
                })(),
                'Origen del Recurso del SAT': catsatOrigenes.find((e) => e.id === item.catsat_origen_recurso)?.descripcion || '',
                Estatus: estados.find((e) => e.id === item.estados_globales)?.descripcion || '',
              }));

              // Datos del tab "Registro" (grid de Parámetros Diversos) de cada Percepción
              setLoading(true);
              const registrosDiversos = await getPercepcionesParametrosDiversos();
              setLoading(false);

              const registroData = (registrosDiversos || []).map((item) => {
                const percepcion = data.find((p) => p.id === item.percepcion);
                const estadoGlobalItem = typeof item.estados_globales === 'object'
                  ? item.estados_globales
                  : null;

                return {
                  'ID Percepción': item.percepcion || '',
                  Clave: percepcion?.clave || '',
                  Percepción: percepcion?.descripcion || '',
                  'Clasificador por Objeto del Gasto (COG)': (() => {
                    const candidatos = simpleData.filter((e) => e.id === item.cog);
                    const ganador = candidatos.find((e) => e.seleccionable === true) || candidatos[0];
                    if (ganador) return `${ganador.clave} - ${ganador.concepto}`;
                    const matchCogs = cogs.find((e) => e.id === item.cog);
                    return matchCogs?.clave ? `${matchCogs.clave} - ${matchCogs.concepto}` : '';
                  })(),
                  'Fuente Financiamiento': (() => {
                    const fuente = fuentesFinanciamientoFlat.find((f) => f.id === item.fuente_financiamiento);
                    return fuente ? `${fuente.clave} - ${fuente.nombre}` : '';
                  })(),
                  'Tipo de Gasto': (() => {
                    const _tipoDeGasto = tipoDeGasto.find((e) => e.id === item.tipo_de_gasto);
                    return _tipoDeGasto?.clave ? `${_tipoDeGasto.clave} - ${_tipoDeGasto.nombre}` : '';
                  })(),
                  'Origen Recurso': catsatOrigenes.find((o) => o.id === item.catsat_origen_recurso)?.descripcion || '',
                  'Tipo Empleado': tiposEmpleadoPresupuestales.find(
                    (t) => t.id === item.tipo_empleado_presupuestal,
                  )?.descripcion || '',
                  'Cuenta Contable': (() => {
                    const _cuentasContables = findInTreeCuentasContables(cuentasContables, item.cuenta_contable);
                    return _cuentasContables
                      ? `${_cuentasContables.clave_visible || _cuentasContables.clave} - ${_cuentasContables.nombre}`
                      : '';
                  })(),
                  'Registro Adicional': item.registro_adicional || '',
                  'Aplica Cuenta Contable por Área': item.aplica_cuenta_contable_por_area ? 'Sí' : 'No',
                  'Vigencia Final': item.vigencia_final ? new Date(item.vigencia_final).toLocaleDateString() : '',
                  Estatus: estadoGlobalItem?.descripcion
                    || estados.find((e) => e.id === item.estados_globales)?.descripcion
                    || '',
                };
              });

              // Crear el archivo Excel
              const workbook = XLSX.utils.book_new();
              const addSheet = (rows, sheetName) => {
                if (!rows.length) return;
                const worksheet = XLSX.utils.json_to_sheet(rows);
                XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

                // Ajustar ancho de columnas
                const colWidths = Object.keys(rows[0] || {}).map((key) => ({
                  wch: Math.max(
                    key.length,
                    ...rows.map((row) => String(row[key] || '').length),
                  ) + 2,
                }));
                worksheet['!cols'] = colWidths;

                // Estilo de cabecera
                const range = XLSX.utils.decode_range(worksheet['!ref']);
                for (let C = range.s.c; C <= range.e.c; C += 1) {
                  const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
                  const cell = worksheet[cellAddress];
                  cell.s = {
                    font: { bold: true, sz: 11 },
                    fill: { patternType: 'solid', fgColor: { rgb: 'D9D9D9' } },
                    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
                  };
                }
              };

              addSheet(exportData, 'Percepciones');
              addSheet(registroData, 'Registro');

              const fileName = `Percepciones_${new Date().toISOString().split('T')[0]}.xlsx`;
              XLSX.writeFile(workbook, fileName);
            }}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Percepción`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            <Tabs
              activeKey={currentTabKey}
              onChange={mutable ? onChangeTabKey : setCurrentTabKey}
              type="card"
            >
              <TabPane
                tab="General"
                key="general"
                forceRender
              >
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={onFinish}
                  scrollToFirstError
                  name="general"
                  initialValues={{
                    es_percepcion_importe_fijo: true,
                  }}
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="clave"
                        rules={rules.clave}
                        label="Clave"
                        hasFeedback
                      >
                        <Input
                          allowClear
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="clave_anterior"
                        label="Clave Anterior"
                      >
                        <Input
                          allowClear
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="descripcion"
                        rules={rules.required}
                        label="Descripción"
                        hasFeedback
                      >
                        <Input
                          allowClear
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="fundamento"
                        label="Fundamento"
                        hasFeedback
                      >
                        <Input
                          allowClear
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="especificacion"
                        label="Especificación"
                        hasFeedback
                      >
                        <Input
                          allowClear
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="fecha_de_alta"
                        label="Vigencia Inicial"
                        rules={rules.required}
                        hasFeedback
                      >
                        <DatePicker
                          allowClear
                          format="DD/MM/YYYY"
                          onChange={(value) => {
                            setFechaAlta(value);
                          }}
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="fecha_de_baja"
                        label="Vigencia Final"
                        rules={rules.fecha_valida}
                        hasFeedback
                      >
                        <DatePicker
                          allowClear
                          format="DD/MM/YYYY"
                          onChange={(val) => {
                            if (val < Date.now() && val) {
                              form.setFieldsValue({
                                estados_globales: 3,
                              });
                            } else {
                              form.setFieldsValue({
                                estados_globales: 1,
                              });
                            }
                          }}
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_percepcion_importe_fijo"
                        rules={rules.required}
                        label="Percepción de Importe Fijo"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          onChange={(value) => {
                            setEsImporteFijo(value);
                            if (value) {
                              setExtraTabKey('fijo');
                            } else {
                              setExtraTabKey('variable');
                            }
                          }}
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="estados_globales"
                        label="Estatus"
                        rules={rules.estatus}
                        hasFeedback
                        initialValue={1}
                      >
                        <Select
                          dataSource={estadosFiltered}
                          disabled={!selectedRowKeys.length || estatusAutorizado || estatusInactivo}
                          onChange={(val) => {
                            if (val === ESTATUS_INACTIVO) {
                              setConfirmationVisibleEstatus(true);
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Form.Item hidden>
                      <Button htmlType="submit" />
                    </Form.Item>
                  </Row>
                </Form>
              </TabPane>
              <TabPane
                tab="Parametrización"
                key="parametrizacion"
                forceRender
              >
                <Form
                  layout="vertical"
                  form={formParametrizacion}
                  onFinish={onFinish}
                  scrollToFirstError
                  name="parametrizacion"
                  initialValues={{
                    aparece_en_tabulador: false,
                    es_solicitable: false,
                    es_recurrente: false,
                    es_incidencia: false,
                    es_percepcion_fija_para_isr: false,
                    es_sueldo: false,
                    es_percepcion_de_finiquito: false,
                    es_percepcion_de_indemnizacion: false,
                    es_subsidio_al_empleo: false,
                    aplica_devolucion_de_isr: false,
                    es_devolucion_isr: false,
                    aparece_en_plazas: false,
                    es_percepcion_con_fecha_fija_de_pago: false,
                    es_reembolso_de_descuento_indebido: false,
                    aplica_retroactivo: false,
                    genera_descuento: false,
                    pago_informativo_para_sat: 1,
                  }}
                  onValuesChange={(changedValues) => {
                    if ('es_percepcion_con_fecha_fija_de_pago' in changedValues) {
                      setMostrarFechaFija(changedValues.es_percepcion_con_fecha_fija_de_pago === true);
                    }

                    if ('pago_informativo_para_sat' in changedValues) {
                      const valor = changedValues.pago_informativo_para_sat;

                      if (valor !== 1) {
                        setMostrarPagoInformativo(true);
                        formRegistro.setFieldsValue({
                          catsat_percepcion: undefined,
                          catsat_origen_recurso: undefined,
                        });
                      } else {
                        setMostrarPagoInformativo(false);
                        formRegistro.setFieldsValue({
                          otro_tipo_pago_nomina: undefined,
                        });
                      }

                      const pagosArr2 = PagosInformativosSAT?.results || PagosInformativosSAT || [];
                      const pagoItem = pagosArr2.find((p) => p.id === valor);
                      setEsPagoDescuentoIndebido(
                        (pagoItem?.descripcion || '').toUpperCase().trim() === 'ES PAGO DE DESCUENTO INDEBIDO',
                      );
                    }

                    if ('aplica_retroactivo' in changedValues && !changedValues.aplica_retroactivo) {
                      formParametrizacion.setFieldsValue({
                        percepcion_relacion_con_retroactivo: undefined, // Recuerda cambiar esto si el nombre en tu backend es diferente
                      });
                    }
                    if ('genera_descuento' in changedValues && !changedValues.genera_descuento) {
                      formParametrizacion.setFieldsValue({
                        descuento_que_se_aplica: undefined,
                      });
                    }
                    if ('es_devolucion_isr' in changedValues && !changedValues.es_devolucion_isr) {
                      formParametrizacion.setFieldsValue({
                        percepcion_de_devolucion: undefined,
                      });
                    }
                    if ('aparece_en_plazas' in changedValues && !changedValues.aparece_en_plazas) {
                      formParametrizacion.setFieldsValue({
                        descripcion_del_importe_para_plazas: undefined,
                        captura_manual_de_importe_en_plaza: false, // <--- Resetear si se apaga el padre
                      });
                    }
                  }}
                >

                  {/* 1. Tipo de percepción */}
                  <SectionCard
                    number={1}
                    title="Tipo de percepción"
                    description="¿Qué clase de percepción es?"
                  >
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_solicitable"
                        rules={rules.required}
                        label="Es Percepción Solicitable"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_incidencia"
                        rules={rules.required}
                        label="Es Percepción de Incidencia"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_recurrente"
                        rules={rules.required}
                        label="Es Percepción Recurrente en cada Nómina"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_percepcion_fija_para_isr"
                        rules={rules.required}
                        label="Es Percepción Fija y Recurrente para ISR Mensual"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_sueldo"
                        rules={rules.required}
                        label="Es Sueldo"
                        hasFeedback
                        extra="Identifica a esta percepción como el sueldo base del empleado en el cálculo de nómina"
                      >
                        <Select
                          trueFalse
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                  </SectionCard>

                  {/* 2. Casos especiales de pago */}
                  <SectionCard
                    number={2}
                    title="Casos especiales de pago"
                    description="Retroactivo, finiquito e indemnización"
                  >
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="aplica_retroactivo"
                        label="Aplica para Pago de Retroactivo"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        shouldUpdate={(prev, curr) => prev.aplica_retroactivo !== curr.aplica_retroactivo}
                        noStyle
                      >
                        {({ getFieldValue }) => {
                          const aplicaRetro = getFieldValue('aplica_retroactivo');
                          return (
                            <Form.Item
                              name="percepcion_relacion_con_retroactivo" // Cambia esto por el nombre exacto de tu API
                              label="Percepción Relacionada con el Retroactivo"
                              rules={aplicaRetro ? rules.required : []}
                              hasFeedback
                            >
                              <Select
                                dataSource={data} // Reutilizamos el estado 'data' que ya tiene las percepciones
                                keyProp="id"
                                labelProp="descripcion"
                                showSearch
                                disabled={!aplicaRetro || estatusAutorizado || estatusInactivo}
                              />
                            </Form.Item>
                          );
                        }}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_percepcion_de_finiquito"
                        rules={rules.required}
                        label="Es Percepción de Finiquito"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          onChange={(value) => {
                            if (value === true) {
                              formParametrizacion.setFieldValue('es_percepcion_de_indemnizacion', !value);
                            }
                          }}
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_percepcion_de_indemnizacion"
                        rules={rules.required}
                        label="Es Percepción de Indemnización"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          onChange={(value) => {
                            if (value === true) {
                              formParametrizacion.setFieldValue('es_percepcion_de_finiquito', !value);
                            }
                          }}
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_percepcion_con_fecha_fija_de_pago"
                        rules={rules.required}
                        label="Es Percepcion con Fecha Fija de Pago"
                        tooltip="Si en 'Es Percepción Solicitable' y 'Es Percepción Recurrente en Cada Nómina' se seleccionó NO, entonces este campo debe ser SÍ para habilitar la programación de fechas de pago."
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>

                    {selectedRowKeys.length > 0 && mostrarFechaFija && (
                      <Col xs={24} sm={24} md={24}>
                        <Text style={{ color: '#D88F4F' }}>Fecha Fija</Text>
                        <PercepcionFechaFijaPago
                          permission={getPermission}
                          selected={selectedRowKeys[0]}
                          estatusAutorizadoInactivo={estatusInactivo}
                          mostrarTabla={mostrarFechaFija}
                        />
                      </Col>
                    )}
                  </SectionCard>

                  {/* 3. ISR y SAT */}
                  <SectionCard
                    number={3}
                    title="ISR y SAT"
                    description="Tratamiento fiscal"
                  >
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="aplica_devolucion_de_isr"
                        label="Aplica Devolución de ISR"
                      >
                        <Select
                          trueFalse
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_devolucion_isr"
                        label="Es Devolución de ISR "
                      >
                        <Select
                          trueFalse
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        shouldUpdate={(prev, curr) => prev.es_devolucion_isr !== curr.es_devolucion_isr}
                        noStyle
                      >
                        {({ getFieldValue }) => {
                          const esDevolucionIsr = getFieldValue('es_devolucion_isr');
                          return (
                            <Form.Item
                              name="percepcion_de_devolucion"
                              label="Percepción de la que es Devolución de ISR"
                              rules={esDevolucionIsr ? rules.required : []}
                              hasFeedback
                            >
                              <Select
                                dataSource={data.filter((item) => item.id !== selectedRowKeys[0])}
                                valueProp="id"
                                keyProp="clave"
                                labelProp="descripcion"
                                keyLabelRender
                                showSearch
                                allowClear
                                disabled={!esDevolucionIsr || estatusAutorizado || estatusInactivo}
                              />
                            </Form.Item>
                          );
                        }}
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="pago_informativo_para_sat"
                        rules={rules.required}
                        label="Es Pago Informativo para el SAT"
                        hasFeedback
                      >
                        <Select
                          dataSource={PagosInformativosSAT}
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="es_reembolso_de_descuento_indebido"
                        rules={rules.required}
                        label="Es Rembolso de Descuento Indebido"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          onChange={(val) => {
                            setEsReembolsoDescuentoIndebido(val === true);
                            if (val === true) {
                              formRegistro.setFieldsValue({
                                catsat_percepcion: undefined,
                                catsat_origen_recurso: undefined,
                              });
                            }
                          }}
                          disabled={estatusAutorizado || estatusInactivo}
                        />

                      </Form.Item>
                    </Col>
                  </SectionCard>

                  {/* 4. Plazas y visualización */}
                  <SectionCard
                    number={4}
                    title="Plazas y visualización"
                    description="Cómo aparece en plazas y recibos"
                  >
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="aparece_en_plazas"
                        rules={rules.required}
                        label="Percepción Aparece en Plazas"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={8}>
                      {/* Render condicional para reglas y disabled */}
                      <Form.Item
                        shouldUpdate={(prev, curr) => prev.aparece_en_plazas !== curr.aparece_en_plazas}
                        noStyle
                      >
                        {({ getFieldValue }) => {
                          const aparece = getFieldValue('aparece_en_plazas');
                          return (
                            <Form.Item
                              name="descripcion_del_importe_para_plazas"
                              label="Descripcion del Importe para Plazas"
                              hasFeedback
                              // requerido solo cuando aparece_en_plazas === true
                              rules={aparece ? rules.required : []}
                            >
                              <Input
                                disabled={!aparece || estatusAutorizado || estatusInactivo}
                              />
                            </Form.Item>
                          );
                        }}
                      </Form.Item>
                    </Col>
                  </SectionCard>

                  {/* 5. Descuento generado automáticamente */}
                  <SectionCard
                    number={5}
                    title="Descuento generado automáticamente"
                    description="Genera un Descuento vinculado al pagarse esta percepción"
                  >
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="genera_descuento"
                        rules={rules.required}
                        label="La Percepción Genera Descuento"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        shouldUpdate={(prev, curr) => prev.genera_descuento !== curr.genera_descuento}
                        noStyle
                      >
                        {({ getFieldValue }) => {
                          const generaDescuento = getFieldValue('genera_descuento');
                          return (
                            <Form.Item
                              name="descuento_que_se_aplica"
                              label="Descuento que se Aplica"
                              rules={generaDescuento ? rules.required : []}
                              hasFeedback
                            >
                              <Select
                                dataSource={descuentos}
                                keyProp="id"
                                labelProp="clave_y_concepto"
                                showSearch
                                allowClear
                                disabled={!generaDescuento || estatusAutorizado || estatusInactivo}
                              />
                            </Form.Item>
                          );
                        }}
                      </Form.Item>
                    </Col>
                  </SectionCard>
                </Form>
              </TabPane>
              <TabPane
                tab="Asignación"
                key="asignacion"
                forceRender
              >
                <Form
                  layout="vertical"
                  form={formAsignacion}
                  onFinish={onFinish}
                  scrollToFirstError
                  name="asignacion"
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="periodicidad_de_percepcion"
                        rules={rules.required}
                        label="Periodicidad de Percepción"
                        hasFeedback
                      >
                        <Select
                          dataSource={periodicidadPercepciones}
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    {/**
                    {selectedRowKeys.length
                      ? (
                        <Col xs={24} sm={24} md={24}>
                          <Text style={{ color: '#D88F4F' }}>Clase de Contratación</Text>
                          <PercepcionClaseDeContratacion
                            permission={getPermission}
                            selected={selectedRowKeys[0]}
                            estatusAutorizadoInactivo={estatusInactivo}
                          />
                        </Col>
                      ) : null}
                     */}
                    {selectedRowKeys.length
                      ? (
                        <Col xs={24} sm={24} md={24}>
                          <Text style={{ color: '#D88F4F' }}>Tipo de Nómina</Text>
                          <PercepcionTipoDeEmpleado
                            permission={getPermissionNomina}
                            selected={selectedRowKeys[0]}
                            estatusAutorizadoInactivo={estatusInactivo}
                          />
                        </Col>
                      ) : null}
                    {selectedRowKeys.length
                      ? (
                        <Col xs={24} sm={24} md={24}>
                          <Text style={{ color: '#D88F4F' }}>Tipo de Empleado</Text>
                          <PercepcionTipoDeNominaEmpleado
                            permission={getPermissionNominaEmpleado}
                            selected={selectedRowKeys[0]}
                            estatusAutorizadoInactivo={estatusInactivo}
                          />
                        </Col>
                      ) : null}
                  </Row>
                </Form>
              </TabPane>
              <TabPane
                tab="Registro"
                key="registro"
                forceRender
              >
                <Form
                  layout="vertical"
                  form={formRegistro}
                  onFinish={onFinish}
                  scrollToFirstError
                  name="registro"
                  initialValues={{
                    afecta_presupuesto: false,
                  }}
                >
                  <Row gutter={10}>
                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="afecta_presupuesto"
                        rules={rules.required}
                        label="Afecta Presupuesto"
                        hasFeedback
                      >
                        <Select
                          trueFalse
                          onChange={(value) => {
                            setAfectaPresupuesto(value);
                            if (value === false) {
                              formRegistro.resetFields(['cog', 'tipo_de_gasto', 'fuente_financiamiento']);
                            }
                          }}
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col>
                    {/* <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="cog"
                        rules={afectaPresupuesto ? rules.required : null}
                        label="Clasificador por Objeto del Gasto (COG)"
                        hasFeedback
                      >
                        <TreeSelect
                          showSearch
                          treeNodeFilterProp="title"
                          treeData={treeData}
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          onChange={(val) => {
                            const idSeleccionado = String(val).split('/').pop();

                            const cogPadre = simpleData.find((e) => String(e.id) === idSeleccionado);

                            if (cogPadre?.clave) {
                              form.setFieldValue('clave', cogPadre.clave);
                              form.setFieldValue('cog', Number(idSeleccionado)); // Aquí ya se guarda solo el ID
                            } else {
                              form.setFieldValue('clave', undefined);
                              form.setFieldValue('cog', undefined);
                            }
                          }}
                          disabled={!afectaPresupuesto || estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col> */}

                    {/* <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="tipo_de_gasto"
                        rules={afectaPresupuesto ? rules.required : null}
                        label="Tipo de Gasto"
                        hasFeedback
                      >
                        <Select
                          labelProp="nombre"
                          keyLabelRender
                          dataSource={tipoDeGasto}
                          disabled={!afectaPresupuesto || estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col> */}
                    {/* <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="fuente_financiamiento"
                        rules={afectaPresupuesto ? rules.required : null}
                        label="Fuente de Financiamiento"
                        hasFeedback
                      >
                        <TreeSelect
                          showSearch
                          treeNodeFilterProp="title"
                          style={{ width: '100%' }}
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          treeData={fuentesFinanciamiento}
                          allowClear
                          onChange={(val) => {
                            formRegistro.setFieldValue('fuente_financiamiento', val);
                          }}
                          disabled={!afectaPresupuesto || estatusAutorizado || estatusInactivo}
                        />

                      </Form.Item>
                    </Col> */}
                    {/* <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="cuenta_contable"
                        rules={rules.required}
                        label="Cuenta Contable del Gasto de la Percepción o Reembolso"
                        hasFeedback
                      >

                        <TreeSelect
                          keyProp="clave"
                          labelProp="nombre"
                          showSearch
                          treeNodeFilterProp="title"
                          treeData={cuentasContables}
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col> */}

                    {/* <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="registro_adicional"
                        label="Registro Adicional"
                        tooltip="Capturar el código que se debe considerar en la póliza contable en lugar de la cuenta de gastos"
                        hasFeedback
                      >

                        <Input
                          disabled={estatusAutorizado || estatusInactivo}
                        />
                      </Form.Item>
                    </Col> */}

                    <Col xs={24} sm={24} md={8}>
                      <Form.Item
                        name="metodo_de_pago"
                        label="Forma de Pago"
                        hasFeedback
                        rules={rules.required}
                      >
                        <Select
                          keyProp="id"
                          labelProp="concepto"
                          mode="multiple" // El campo sigue siendo M2M en el backend (sin cambios
                          // ahí); aquí solo se restringe la UI a un único valor seleccionado.
                          dataSource={formasDePago} // Usa los datos de la API
                          disabled={estatusAutorizado || estatusInactivo}
                          onChange={(values) => {
                            const ultimoValor = values?.length
                              ? [values[values.length - 1]] : [];
                            formRegistro.setFieldValue('metodo_de_pago', ultimoValor);
                          }}
                        />
                      </Form.Item>
                    </Col>

                    {!mostrarPagoInformativo && !esReembolsoDescuentoIndebido && (
                      <>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="catsat_percepcion"
                            rules={rules.required}
                            label="Percepción del SAT"
                            hasFeedback
                          >
                            <Select
                              keyLabelRender
                              dataSource={catsatPercepciones}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        {/* <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="catsat_origen_recurso"
                            rules={rules.required}
                            label="Origen del Recurso del SAT"
                            hasFeedback
                          >
                            <Select
                              keyLabelRender
                              dataSource={catsatOrigenes}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col> */}
                      </>
                    )}

                    {mostrarPagoInformativo && (
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="otro_tipo_pago_nomina"
                          rules={rules.required}
                          label="Tipos de Otros Pagos del SAT"
                          hasFeedback
                        >
                          <Select
                            keyProp="clave"
                            labelProp="descripcion"
                            keyLabelRender
                            dataSource={otrosTiposPagoNominas}
                            showSearch
                            disabled={estatusAutorizado || estatusInactivo}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    <PercepcionesParametrosDiversos
                      percepcionId={selectedRowKeys[0]}
                      permission={permission}
                      onCheckAplicaContable={verificarRegistrosContables}
                      onRowSelected={handleParametroDiversoSeleccionado}
                      esPagoDescuentoIndebido={esPagoDescuentoIndebido}
                    />
                    {mostrarRegistrosContables && (
                      <RegistroContablePercepciones
                        percepcionId={selectedRowKeys[0]}
                        permission={permission}
                        initialTipoEmpleado={tipoEmpleadoPreseleccionado}

                      />
                    )}

                  </Row>
                </Form>
              </TabPane>
              <TabPane
                tab="Importe"
                key="importe"
                forceRender
              >
                <Tabs
                  activeKey={extraTabKey}
                  onChange={mutable ? onChangeTabKeyExtra : setExtraTabKey}
                  type="card"
                >
                  <TabPane
                    tab="Fijo"
                    key="fijo"
                    forceRender
                    disabled={!esImporteFijo}
                  >
                    <Form
                      layout="vertical"
                      form={formFijo}
                      onFinish={onFinish}
                      scrollToFirstError
                      name="fijo"
                      onValuesChange={disableVariante}
                      initialValues={{
                        aplica_no_dias_fijos: false,
                        aplica_dias_laborados: false,
                        aplica_importe_diario_fijo: false,
                        aplica_importe_mensual: false,
                        aplica_importe_fijo_por_evento: false,
                        aplica_importe_fijo_por_periodo_de_nomina: false,
                        aplica_importe_fijo_anual: false,
                        aplica_pago_por_numero_de_dias_laborados: false,
                      }}
                    >

                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_dias_laborados"
                            rules={esImporteFijo ? rules.required : null}
                            label="Aplica Pago por Número de Días Laborados"
                            hasFeedback
                          >
                            <Select
                              trueFalse
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_no_dias_fijos"
                            label="Aplica Pago por Número de Días Fijo"
                            rules={esImporteFijo ? rules.required : null}
                            hasFeedback
                          >
                            <Select
                              trueFalse
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            name="no_dias_fijos"
                            label="Número de Días Fijo"
                            rules={aplicaDiasFijo ? rules.required : null}
                            disabled={!aplicaDiasFijo || estatusAutorizado || estatusInactivo}
                          />
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_importe_diario_fijo"
                            rules={esImporteFijo ? rules.required : null}
                            label="Aplica Importe Diario Fijo"
                            hasFeedback
                          >
                            <Select
                              trueFalse
                              onChange={(value) => {
                                if (value) {
                                  formFijo.setFieldsValue({
                                    aplica_importe_mensual: false,
                                    aplica_importe_fijo_por_evento: false,
                                  });
                                  formFijo.resetFields(['importe_mensual', 'importe_fijo_por_evento']);
                                  setAplicaImporteMensual(!value);
                                  setAplicaImporteEvento(!value);
                                }
                              }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <CurrencyInput
                            name="importe_diario"
                            label="Importe Diario Fijo"
                            rules={aplicaImporteFijo ? rules.required : null}
                            disabled={!aplicaImporteFijo || estatusAutorizado || estatusInactivo}
                          />
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_importe_mensual"
                            rules={esImporteFijo ? rules.required : null}
                            label="Aplica Importe Mensual Fijo"
                            hasFeedback
                          >
                            <Select
                              trueFalse
                              onChange={(value) => {
                                if (value) {
                                  formFijo.setFieldsValue({
                                    aplica_importe_diario_fijo: false,
                                    aplica_importe_fijo_por_evento: false,
                                  });
                                  formFijo.resetFields(['importe_diario', 'importe_fijo_por_evento']);
                                  setAplicaImporteFijo(!value);
                                  setAplicaImporteEvento(!value);
                                }
                              }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <CurrencyInput
                            name="importe_mensual"
                            label="Importe Mensual Fijo"
                            rules={aplicaImporteMensual ? rules.required : null}
                            disabled={!aplicaImporteMensual || estatusAutorizado || estatusInactivo}
                          />
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_importe_fijo_por_evento"
                            rules={esImporteFijo ? rules.required : null}
                            label="Aplica Importe Fijo por Evento"
                            hasFeedback
                          >
                            <Select
                              trueFalse
                              onChange={(value) => {
                                if (value) {
                                  formFijo.setFieldsValue({
                                    aplica_importe_mensual: false,
                                    aplica_importe_diario_fijo: false,
                                  });
                                  formFijo.resetFields(['importe_mensual', 'importe_diario']);
                                  setAplicaImporteFijo(!value);
                                  setAplicaImporteMensual(!value);
                                }
                              }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <CurrencyInput
                            name="importe_fijo_por_evento"
                            label="Importe Fijo por Evento"
                            rules={aplicaImporteEvento ? rules.required : null}
                            disabled={!aplicaImporteEvento || estatusAutorizado || estatusInactivo}
                          />
                        </Col>
                      </Row>

                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_importe_fijo_por_periodo_de_nomina"
                            label="Aplica Importe Fijo por Periodo de Nómina"
                          >
                            <Select
                              trueFalse
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <CurrencyInput
                            name="importe_fijo_por_periodo_de_nomina"
                            label="Importe Fijo por Periodo de Nómina"
                            rules={aplicaImporteFijoPeriodo ? rules.required : null}
                            disabled={!aplicaImporteFijoPeriodo || estatusAutorizado || estatusInactivo}
                          />
                        </Col>

                      </Row>

                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_importe_fijo_anual"
                            label="Aplica Importe Fijo Anual"
                          >
                            <Select
                              trueFalse
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>

                          <CurrencyInput
                            name="importe_fijo_anual"
                            label="Importe Fijo Anual"
                            rules={aplicaImporteFijoAnual ? rules.required : null}
                            disabled={!aplicaImporteFijoAnual || estatusAutorizado || estatusInactivo}
                          />
                        </Col>

                      </Row>

                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_pago_por_numero_de_dias_laborados"
                            label="Aplica Pago Por Numero de Días Laborados"
                          >
                            <Select
                              trueFalse
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                      </Row>

                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="vigente_al"
                            label="Vigencia Final"
                            hasFeedback
                          >
                            <DatePicker
                              allowClear
                              format="DD/MM/YYYY"
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </TabPane>
                  <TabPane
                    tab="Variable"
                    key="variable"
                    forceRender
                    disabled={esImporteFijo}
                  >
                    <Form
                      layout="vertical"
                      form={formVariable}
                      onFinish={onFinish}
                      scrollToFirstError
                      name="variable"
                      initialValues={{
                        aplica_importe_variable_por_parametro: false,
                        aplica_importe_variable_por_evento: false,
                        aplica_no_de_dias_laborados: false,
                        aplica_salario_diario_de_empleado: false,
                        aplica_pago_por_hora: false,
                        aplica_pago_por_dia: false,
                        aplica_porcentaje_unico_de_percepcion: false,
                        aplica_antiguedad_laboral: false,
                        aplica_no_de_dias_porcentaje: false,
                      }}
                    >
                      <Row gutter={10}>

                        {/* <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_salario_diario_tabular"
                            label="Aplica Pago con Salario Diario Tabular"
                            hasFeedback
                            rules={!esImporteFijo ? rules.required : null}
                            initialValue={false}
                          >
                            <Select
                              trueFalse
                              onChange={(value) => {
                                if (value) {
                                  formVariable.setFieldsValue({
                                    aplica_salario_diario_nominal: false,
                                    aplica_importe_variable_por_evento: false,
                                    aplica_salario_diario_de_empleado: false,
                                  });
                                }
                              }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col> */}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_importe_variable_por_parametro"
                            label="Aplica Importe Variable Por Parámetro"
                            hasFeedback
                            rules={!esImporteFijo ? rules.required : null}
                            initialValue={false}
                          >
                            <Select
                              trueFalse
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_importe_variable_por_evento"
                            label="Aplica Importe Variable por Evento"
                            hasFeedback
                            rules={!esImporteFijo ? rules.required : null}
                            initialValue={false}
                          >
                            <Select
                              trueFalse
                              onChange={(value) => {
                                setAplicaImporteVariableEvento(value);
                                if (value) {
                                  setAplicaPagoHora(!value);
                                  setAplicaPagoDia(!value);
                                  setAplicaPorcentajePercepcion(!value);
                                  formVariable.setFieldsValue({
                                    aplica_pago_por_hora: false,
                                    aplica_pago_por_dia: false,
                                    aplica_porcentaje_unico_de_percepcion: false,
                                    aplica_salario_diario_tabular: false,
                                    aplica_salario_diario_de_empleado: false,
                                  });
                                  formVariable.resetFields([
                                    'no_de_veces_de_pago_por_hora',
                                    'no_de_veces_de_pago_por_dia',
                                    'porcentaje_unico_percepcion',
                                    'formula',
                                  ]);
                                }
                              }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_no_de_dias_laborados"
                            label="Aplica Pago por Número de Días Laborados "
                            hasFeedback
                            rules={!esImporteFijo ? rules.required : null}
                            initialValue={false}
                          >
                            <Select
                              trueFalse
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_salario_diario_de_empleado"
                            label="Aplica Pago con Salario Diario del Empleado"
                            hasFeedback
                            rules={!esImporteFijo ? rules.required : null}
                            initialValue={false}
                          >
                            <Select
                              trueFalse
                              onChange={(value) => {
                                if (value) {
                                  formVariable.setFieldsValue({
                                    aplica_importe_variable_por_evento: false,
                                    aplica_salario_diario_tabular: false,
                                  });
                                }
                              }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_pago_por_hora"
                            label="Aplica Pago por Hora"
                            hasFeedback
                            rules={!esImporteFijo ? rules.required : null}
                            initialValue={false}
                          >
                            <Select
                              trueFalse
                              onChange={(value) => {
                                setAplicaPagoHora(value);
                                formVariable.resetFields(['no_de_veces_de_pago_por_hora']);
                                if (value) {
                                  formVariable.setFieldsValue({
                                    aplica_pago_por_dia: false,
                                    aplica_porcentaje_unico_de_percepcion: false,
                                    aplica_importe_variable_por_evento: false,
                                  });
                                  formVariable.resetFields(['no_de_veces_de_pago_por_dia', 'porcentaje_unico_percepcion']);
                                  setAplicaPagoDia(false);
                                  setAplicaPorcentajePercepcion(false);
                                }
                              }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            name="no_de_veces_de_pago_por_hora"
                            label="Número de Veces de Pago por Hora"
                            rules={aplicaPagoHora ? rules.dias : null}
                            disabled={!aplicaPagoHora || estatusAutorizado || estatusInactivo}
                          />
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_pago_por_dia"
                            label="Aplica Pago por Día"
                            rules={!esImporteFijo ? rules.required : null}
                            hasFeedback
                            initialValue={false}
                          >
                            <Select
                              trueFalse
                              onChange={(value) => {
                                setAplicaPagoDia(value);
                                formVariable.resetFields(['no_de_veces_de_pago_por_dia']);
                                if (value) {
                                  formVariable.setFieldsValue({
                                    aplica_pago_por_hora: false,
                                    aplica_importe_variable_por_evento: false,
                                    aplica_porcentaje_unico_de_percepcion: false,
                                  });
                                  formVariable.resetFields(['no_de_veces_de_pago_por_hora', 'porcentaje_unico_percepcion']);
                                  setAplicaPagoHora(false);
                                  setAplicaPorcentajePercepcion(false);
                                }
                              }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <NumericInput
                            name="no_de_veces_de_pago_por_dia"
                            label="Número de Veces de Pago por Día"
                            rules={aplicaPagoDia ? rules.dias : null}
                            disabled={!aplicaPagoDia || estatusAutorizado || estatusInactivo}
                          />
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_porcentaje_unico_de_percepcion"
                            label="Aplica % Único de Percepción"
                            rules={!esImporteFijo ? rules.required : null}
                            hasFeedback
                            initialValue={false}
                          >
                            <Select
                              trueFalse
                              onChange={(value) => {
                                setAplicaPorcentajePercepcion(value);
                                formVariable.resetFields(['porcentaje_unico_percepcion']);
                                if (value) {
                                  formVariable.setFieldsValue({
                                    aplica_importe_pagado_por_solicitud: false,
                                    aplica_pago_por_hora: false,
                                    aplica_pago_por_dia: false,
                                    aplica_importe_variable_por_evento: false,
                                  });
                                  formVariable.resetFields(['no_de_veces_de_pago_por_hora', 'no_de_veces_de_pago_por_dia']);
                                  setAplicaPagoHora(false);
                                  setAplicaPagoDia(false);
                                }
                              }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={8}>
                          <PercentageInput
                            name="porcentaje_unico_percepcion"
                            label="% Único de Percepción"
                            rules={aplicaPorcentajePercepcion ? rules.porcentaje : null}
                            disabled={!aplicaPorcentajePercepcion || estatusAutorizado || estatusInactivo}
                          />
                        </Col>
                      </Row>
                      <Row gutter={10}>
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_antiguedad_laboral"
                            label="Aplica Antigüedad Laboral"
                            hasFeedback
                            rules={!esImporteFijo ? rules.required : null}
                            initialValue={false}
                          >
                            <Select
                              trueFalse
                              onChange={(value) => {
                                setAplicaAntiguedad(value);
                                if (value) {
                                  formVariable.setFieldsValue({
                                    aplica_no_de_dias_porcentaje: false,
                                  });
                                  setAplicaDiasPorcentaje(false);
                                }
                              }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        {selectedRowKeys.length && aplicaAntiguedad
                          ? (
                            <Col xs={24} sm={24} md={24}>
                              <Text style={{ color: '#D88F4F' }}>Aplica Antigüedad Laboral</Text>
                              <PercepcionConfiguracionAntiguedad
                                permission={getPermissionAntiguedad}
                                selected={selectedRowKeys[0]}
                                estatusAutorizadoInactivo={estatusAutorizado || estatusInactivo}
                              />
                            </Col>
                          ) : null}
                        <Col xs={24} sm={24} md={8}>
                          <Form.Item
                            name="aplica_no_de_dias_porcentaje"
                            label="Aplica Número de Días y Porcentaje"
                            hasFeedback
                            rules={!esImporteFijo ? rules.required : null}
                            initialValue={false}
                          >
                            <Select
                              trueFalse
                              onChange={(value) => {
                                setAplicaDiasPorcentaje(value);
                                if (value) {
                                  formVariable.setFieldsValue({
                                    aplica_antiguedad_laboral: false,
                                  });
                                  setAplicaAntiguedad(false);
                                }
                              }}
                              disabled={estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                        {selectedRowKeys.length && aplicaDiasPorcentaje
                          ? (
                            <Col xs={24} sm={24} md={24}>
                              <Text style={{ color: '#D88F4F' }}>Aplica Número de Dïas y Porcentaje</Text>
                              <PercepcionConfiguracionAntiguedad
                                permission={getPermissionAntiguedad}
                                antiguedadLaboral={false}
                                selected={selectedRowKeys[0]}
                                estatusAutorizadoInactivo={estatusAutorizado || estatusInactivo}
                              />
                            </Col>
                          ) : null}
                        <Col xs={24} sm={24} md={24}>
                          <Form.Item
                            name="formula"
                            label="Fórmula"
                            hasFeedback
                          >
                            <Input
                              allowClear
                              disabled={aplicaImporteVariableEvento
                                || estatusAutorizado || estatusInactivo}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Form>
                  </TabPane>

                </Tabs>
              </TabPane>
              {/* ... Tabs anteriores ... */}

              <TabPane
                tab="Otros Parámetros"
                key="otrosParametros"
              // forceRender
              >
                <Form
                  layout="vertical"
                  form={formOtrosParametros}
                  onFinish={onFinish}
                  scrollToFirstError
                  name="otrosParametros"
                  initialValues={{
                    [nameAreaComision]: false,
                    [nameAplicaFechas]: false,
                    [nameAplicaNumeroDias]: false,
                    tiene_limite_maximo_sueldo: false,
                    aplica_tipo_empleados: false,
                    aplica_antiguedad_minima: false,
                    aparece_en_plazas: false,
                    aplica_incidencias_reloj_checador: false,
                    aplica_importe_por_puesto: false,
                    aplica_sindicalizado: false,
                    aplica_antiguedad_del_empleado: false,
                    aplica_proporcion_dias_laborados: false,
                    aplica_importe_por_plaza: false,
                    aplica_incidencias_de_reloj_checador: false,
                    aplica_tipo_de_empleados: false,
                    aplica_exclusion_por_tipo_de_empleados: false,
                  }}
                >
                  <Card
                    type="inner"
                    size="small"
                    className="inner-block-card"
                    title="1. Restricciones De Importe Y Sueldo"
                    extra="Topes Y Criterios Por Plaza O Puesto"
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="tiene_limite_maximo_sueldo"
                          label="Tiene Límite Máximo de Sueldo"
                        >
                          <Select
                            trueFalse
                            onChange={(val) => setAplicaLimiteSueldo(val)}
                            disabled={estatusAutorizado || estatusInactivo}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="aplica_importe_por_plaza"
                          label="Aplica Importe por Plaza"
                          rules={rules.required}
                        >
                          <Select
                            trueFalse
                            onChange={(val) => setAplicaImportePlaza(val)}
                            disabled={estatusAutorizado || estatusInactivo}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="aplica_importe_por_puesto"
                          label="Aplica Importe por Puesto"
                        >
                          <Select trueFalse disabled={estatusAutorizado || estatusInactivo} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                  <Card
                    type="inner"
                    size="small"
                    className="inner-block-card"
                    title="2. Restricciones De Empleado"
                    extra="Tipo, Sindicato Y Antigüedad"
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="aplica_tipo_de_empleados"
                          label="Aplica Tipo de Empleados"
                        >
                          <Select
                            trueFalse
                            onChange={(val) => {
                              setAplicaTipoEmpleado(val);
                            }}
                            disabled={estatusAutorizado || estatusInactivo}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="aplica_exclusion_por_tipo_de_empleados"
                          label="Aplica Exclusión por Tipo de Empleados"
                        >
                          <Select
                            trueFalse
                            onChange={(val) => {
                              setAplicaExclusionTipoEmpleado(val);
                            }}
                            disabled={estatusAutorizado || estatusInactivo}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="aplica_sindicalizado"
                          label="Aplica a Sindicalizados"
                        >
                          <Select trueFalse disabled={estatusAutorizado || estatusInactivo} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="aplica_antiguedad_del_empleado"
                          label="Aplica Antigüedad del Empleado"
                        >
                          <Select trueFalse disabled={estatusAutorizado || estatusInactivo} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="aplica_antiguedad_minima"
                          label="Aplica Antigüedad Mínima"
                        >
                          <Select
                            trueFalse
                            onChange={(val) => {
                              setAplicaAntiguedadMinima(val);
                              if (!val) formOtrosParametros.setFieldsValue({ antiguedad_minima: null });
                            }}
                            disabled={estatusAutorizado || estatusInactivo}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="antiguedad_minima"
                          label="Antigüedad Mínima"
                          rules={aplicaAntiguedadMinima ? rules.required : []}
                        >
                          <Input
                            suffix="Días"
                            type="number"
                            disabled={!aplicaAntiguedadMinima || estatusAutorizado || estatusInactivo}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                  <Card
                    type="inner"
                    size="small"
                    className="inner-block-card"
                    title="3. Tiempo, Asistencia Y Período"
                    extra="Días, Fechas E Incidencias"
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name={nameAplicaIncidenciasReloj}
                          label="Aplica Incidencias de Reloj Checador"
                        >
                          <Select trueFalse disabled={estatusAutorizado || estatusInactivo} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name="aplica_proporcion_dias_laborados"
                          label="Aplica Proporción de Días Laborados"
                        >
                          <Select trueFalse disabled={estatusAutorizado || estatusInactivo} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name={nameAplicaNumeroDias}
                          label="Aplica Número de Días de Pago"
                          rules={rules.required}
                        >
                          <Select trueFalse disabled={estatusAutorizado || estatusInactivo} />
                        </Form.Item>
                      </Col>
                      <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                          const flag = getFieldValue(nameAplicaNumeroDias);
                          return flag && (
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                name="numero_dias_de_pago"
                                label="Número de Días de Pago"
                                rules={rules.required}
                              >
                                <InputNumber
                                  style={{ width: '100%' }}
                                  disabled={estatusAutorizado || estatusInactivo}
                                />
                              </Form.Item>
                            </Col>
                          );
                        }}
                      </Form.Item>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name={nameAplicaFechas}
                          label="Aplica Rango de Fechas"
                          rules={rules.required}
                        >
                          <Select trueFalse disabled={estatusAutorizado || estatusInactivo} />
                        </Form.Item>
                      </Col>
                      <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                          const flag = getFieldValue(nameAplicaFechas);
                          return flag && (
                            <>
                              <Col xs={24} sm={24} md={8}>
                                <Form.Item
                                  name="fecha_inicial"
                                  label="Fecha Incial"
                                  rules={rules.required}
                                  hasFeedback
                                >
                                  <DatePicker
                                    allowClear
                                    format="DD/MM/YYYY"
                                    disabled={estatusAutorizado || estatusInactivo}
                                  />
                                </Form.Item>
                              </Col>
                              <Col xs={24} sm={24} md={8}>
                                <Form.Item
                                  name="fecha_final"
                                  label="Fecha Final"
                                  rules={rules.required}
                                  hasFeedback
                                >
                                  <DatePicker
                                    allowClear
                                    format="DD/MM/YYYY"
                                    disabled={estatusAutorizado || estatusInactivo}
                                  />
                                </Form.Item>
                              </Col>
                            </>
                          );
                        }}
                      </Form.Item>
                    </Row>
                  </Card>
                  <Card
                    type="inner"
                    size="small"
                    className="inner-block-card"
                    title="4. Otros Criterios"
                    extra="Comisiones Y Parámetros Adicionales"
                  >
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={8}>
                        <Form.Item
                          name={nameAreaComision}
                          label="Aplica Área de Comisión"
                          rules={rules.required}
                        >
                          <Select trueFalse disabled={estatusAutorizado || estatusInactivo} />
                        </Form.Item>
                      </Col>
                      <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => {
                          const flag = getFieldValue(nameAreaComision);
                          return flag && (
                            <Col xs={24} sm={24} md={8}>
                              <Form.Item
                                name="area_externa"
                                label="Directorio Externo"
                                rules={rules.required}
                              >
                                <Select
                                  labelProp="nombre_del_area"
                                  dataSource={directoriosExternos}
                                  style={{ width: '100%' }}
                                  disabled={estatusAutorizado || estatusInactivo}
                                />
                              </Form.Item>
                            </Col>
                          );
                        }}
                      </Form.Item>
                    </Row>
                  </Card>
                  <Row gutter={10}>
                    <Col xs={24}>
                      {/* 0. Tabla Importe Límite Máximo */}
                      {aplicaLimiteSueldo && (
                        <div style={{ marginTop: 20 }}>
                          <Text style={{ color: '#D88F4F' }}>Configuración de Importe Límite Máximo</Text>
                          <PercepcionesLimiteMaximo
                            percepcionId={selectedRowKeys[0]}
                            permission={permission}
                          />
                        </div>
                      )}

                      {/* 1. Tabla Plazas */}
                      {aplicaImportePlaza && (
                        <div style={{ marginTop: 20 }}>
                          <Text style={{ color: '#D88F4F' }}>Configuración de Importe por Plaza</Text>
                          <PercepcionImportePlaza
                            percepcionId={selectedRowKeys[0]}
                            permission={permission}
                          />
                        </div>
                      )}

                      {/* 1b. Tabla Tipos de Empleado */}
                      {aplicaTipoEmpleado && (
                        <div style={{ marginTop: 20 }}>
                          <Text style={{ color: '#D88F4F' }}>Configuración de Tipos de Empleado</Text>
                          <PercepcionTiposDeEmpleadoConfig
                            percepcionId={selectedRowKeys[0]}
                            permission={permission}
                          />
                        </div>
                      )}

                      {/* 1c. Tabla Exclusión por Tipo de Empleado */}
                      {aplicaExclusionTipoEmpleado && (
                        <div style={{ marginTop: 20 }}>
                          <Text style={{ color: '#D88F4F' }}>Configuración de Exclusión por Tipo de Empleado</Text>
                          <PercepcionesExcluirPorTipoDeEmpleadoConfig
                            percepcionId={selectedRowKeys[0]}
                            permission={permission}
                          />
                        </div>
                      )}

                      {/* 2. Tabla Puestos  */}
                      {!!selectedRowKeys.length && aplicaImportePuesto && (
                        <div style={{ marginTop: 20 }}>
                          <Text style={{ color: '#D88F4F' }}>Configuración de Importe por Puesto</Text>
                          <PercepcionImportePuesto
                            percepcionId={selectedRowKeys[0]}
                            permission={permission}
                          />
                        </div>
                      )}

                      {/* 3. Tabla Incidencias  */}
                      {!!selectedRowKeys.length && aplicaIncidenciasReloj && (
                        <div style={{ marginTop: 20 }}>
                          <Text style={{ color: '#D88F4F' }}>Configuración de Incidencias Reloj</Text>
                          <PercepcionIncidenciasReloj
                            percepcionId={selectedRowKeys[0]}
                            permission={permission}
                          />
                        </div>
                      )}
                    </Col>
                  </Row>

                </Form>
              </TabPane>
            </Tabs>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Percepción ${form.getFieldValue('descripcion')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          onFinishText="Continuar"
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          title="Confirmación"
          contentTitle={`Autorizar la Percepción ${form.getFieldValue('descripcion')}`}
          ConfirmAutorize
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishCancelar}
          ConfirmCancel
          onCancel={() => {
            setConfirmationCancelarVisible(false);
          }}
          open={confirmationCancelarVisible}
          title="Confirmación"
          contentTitle={`Cancelar la Percepción ${form.getFieldValue('descripcion')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishReactivar}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => {
            setConfirmationReactivarVisible(false);
          }}
          open={confirmationReactivarVisible}
          title="Confirmación"
          contentTitle={`Reactivar la Percepción ${form.getFieldValue('descripcion')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          onFinishText="Continuar"
          onCancel={() => {
            setConfirmationVisibleEstatus(false);
            form.setFieldValue('estados_globales', 1);
          }}
          open={confirmationVisibleEstatus}
          title="Confirmación"
          contentTitle={`Inactivar la Percepción ${form.getFieldValue('descripcion')}`}
          ConfirmInactive
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default Percepcion;
